import { render, staticRenderFns } from "./foreign-company.vue?vue&type=template&id=0ada20f6&"
import script from "./foreign-company.ts?vue&type=script&lang=ts&"
export * from "./foreign-company.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports